import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { Annotator } from "@labelu/audio-annotator-react";
import "@labelu/audio-annotator-react/dist/style.css";
interface AudioAnnotationTypeActionProps {
  action_value?: any;
}

export default function AudioAnnotationTypeAction({ action_value }: AudioAnnotationTypeActionProps) {
  const [annotatorData, setAnnotatorData] = useState<
    { id: string; samples: any[]; config: { segment: any[] }; defaultLabel?: string }[]
  >([]);

  // const annotatorRef = useRef<any>(null);
  const DEFAULT_AUDIO_URL = "https://data-platform-resources.s3.ap-south-1.amazonaws.com/file_example_MP3_700KB20240802Augh08m1722563048s.mp3";

  useEffect(() => {
    if (action_value?.length > 0) {
      const data = action_value.map((action: any) => {
        const configItems = action?.config_details?.value?.value ?? [];
        const annotations = action?.annotations?.segment ?? [];

        const segmentConfig = configItems.map((item: any) => ({
          color: item.color,
          key: item.name,
          value: item.name.toLowerCase(),
        }));

        const defaultLabel = configItems[0]?.name?.toLowerCase();

        return {
          id: action.id,
          samples: [
            {
              id: `sample-${action.id}`,
              url: action?.default_value || DEFAULT_AUDIO_URL,
              name: "Sample Audio",
              data: { segment: annotations },
            },
          ],
          config: { segment: segmentConfig },
          defaultLabel,
        };
      });

      setAnnotatorData(data);
    }
  }, [action_value]);

  return (
    <>
      
      {annotatorData.map((data) => {
        return (
          <div
            key={data.id}
            style={{ display: "flex", marginBottom: "20px", flexDirection: "column" }}
          >
            <Typography sx={{ fontWeight: "bold", marginBottom: "10px" }}>
              Audio Annotation :
            </Typography>
            <Annotator
              //ref={annotatorRef}
              selectedLabel={data.defaultLabel}
              samples={data.samples}
              config={data.config}
            />
          </div>
        );
      })}

    </>
  );
}
